import * as CRM from './CRM';
import * as MARKETING from './Marketing';
import * as SALES from './Sales';
import * as SERVICE from './Service';
import * as CMS from './CMS';
import * as OPS from './Operations';
import * as ALL_FEATURES from '../HubSpotFeature';
export const BY_PRODUCT = {
  CRM,
  MARKETING,
  SALES,
  SERVICE,
  CMS,
  OPS
};
export const OPS_HUB_FEATURES = [ALL_FEATURES.CRM_DATA_SYNC, ALL_FEATURES.OPS_HUB_CUSTOM_FIELD_MAPPINGS, ALL_FEATURES.CRM_LINKEDIN_SYNC];